export interface RepresentativeMerchantAccess {
  MerchantAccessId: number;
  MerchantId: number;
  MerchantName: string;
}

export interface MerchantRepresentativeAccess {
  MerchantAccessId: number;
  RepresentativeId: number;
  RepresentativeName: string;
  EmailAddress?: string;
  IsPrimary: boolean;
}
